import { checkIfDomainExists } from "../helpers/helpers";
import { Constants } from "./constants"


export function getImageUrl(name) {

const fileName = name.split(".")?.[0] || name;

return Constants.publicPath.productionServer + fileName;
}

export function openImageInNewTab(url) {
    if (url) {
       
        window.open(checkIfDomainExists(url), "_blank");
    }
}


export function getDocumentURL(url) {
    if (url) {
      
        return Constants.URL.base + url
    }
}


export function isFileExtension(extensionName,fileExtensionRecieved)
{
   
        return fileExtensionRecieved === extensionName
    

}